module.exports = __webpack_public_path__ + "img/comedy.6d8e8ee3.svg";